import { useEffect } from 'react';

import { isNotFound } from '../forces/utils/errors';
import { captureExceptionInSentry } from '../utils/errorTracker/tracking';

/** A not-found is an expected outcome, not a failure */
export const useReportUnlessNotFound = (error: unknown) => {
  useEffect(() => {
    if (error && !isNotFound(error)) {
      captureExceptionInSentry(error as Error);
    }
  }, [error]);
};
